import { TextField } from "@mui/material";

const formatDocument = (value) => {
    const numericValue = value.replace(/\D/g, "").slice(0, 14); // Remove não numéricos e limita a 14 dígitos

    if (numericValue.length <= 11) {
        // CPF
        return numericValue
            .replace(/^(\d{3})(\d)/, "$1.$2")
            .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
            .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3-$4");
    } else {
        // CNPJ
        return numericValue
            .replace(/^(\d{2})(\d)/, "$1.$2")
            .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
            .replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3/$4")
            .replace(/^(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})(\d)/, "$1.$2.$3/$4-$5");
    }
};

const DocumentInput = ({ documentNumber, setDocumentNumber }) => {
    const handleChange = (e) => {
        const rawValue = e.target.value;
        setDocumentNumber(formatDocument(rawValue));
    };

    return (
        <TextField
            label="Documento"
            fullWidth
            value={documentNumber}
            onChange={handleChange}
            inputMode="numeric"
        />
    );
};

export default DocumentInput;
